/**
 * A component for rendering breaks in cards
 */

import { Component } from '@angular/core';

@Component({
  selector: 'va-card-break-line',
  template: '',
  styleUrls: ['./va-card-break-line.component.scss'],
  standalone: false,
})
export class VaCardBreakLineComponent {}
